import React from "react";
import { Navigate } from "react-router-dom";
const PreventLoginPage = ({ children }) => {
  const token = localStorage.getItem("token");
  // If user already logged in → redirect to dashboard
  if (token) {
    return <Navigate to="/personal" replace />;
  }
  return children;
};

export default PreventLoginPage;
